export default "<p>trips works!</p>\n"